import { Routes } from '@angular/router';
import { privateGuard } from './guards/private.guard';
import { SiteComponent } from './pages/site/site.component';

export const routes: Routes = [
  {
    path: 'app',
    component: SiteComponent,
  },
  { path: '**', redirectTo: 'app' },
];
